export default __webpack_public_path__ + "locales/lv/FilesSettings.json?hash=6ce9054933ca9c517622ea4bacc5767b";